import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AdminSchoolUserService} from '../../../../../services/admin/admin-school-user.service';
import {UserModel} from '../../../../../models/authentication/user.model';
import {EVOSegmentedControlItem} from '../../../../../shared/reusable-controls/evo-segmented-control/evo-segmented-control.component';
import {AdminSchoolService} from '../../../../../services/admin/admin-school.service';
import {SchoolFilter, SchoolModel} from '../../../../../models/school/school.model';

@Component({
  selector: 'app-evo-school-school-user-edit',
  templateUrl: './evo-admin-school-user-edit.component.html',
  styleUrls: ['./evo-admin-school-user-edit.component.css']
})
export class EvoAdminSchoolUserEditComponent implements OnInit {

  isEditMode = false;
  schoolId: string;
  userId: string;
  user: UserModel;
  school: SchoolModel;
  teacherTestSchool: SchoolModel;

  controls: EVOSegmentedControlItem[] = [
    new EVOSegmentedControlItem('students', 'schoolAdministration.students.title'),
    new EVOSegmentedControlItem('groups', 'schoolAdministration.groups.title'),
    new EVOSegmentedControlItem('settings', 'sidebar.settings')
  ];

  currentItem: EVOSegmentedControlItem = this.controls[0];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private adminSchoolSv: AdminSchoolService,
              private schoolUserAdminService: AdminSchoolUserService) { }

  ngOnInit() {

    const urlParams = this.router.url.split('/');
    const page = urlParams[urlParams.length - 1];

    for (const item of this.controls) {
      if (item.key === page) {
        this.currentItem = item;
      }
    }

    this.route.params.subscribe((params: Params) => {

      this.schoolId = params.schoolId;
      this.userId = params.userId;

      if (this.userId) {
        console.log('has user id: ' + this.userId);
        this.schoolUserAdminService.fetchSchoolUserById(this.schoolId,  this.userId).subscribe((user) => {

          console.log('fetch school user: ' + JSON.stringify(user));
          this.user = user;
          if (this.schoolId) {
            console.log('fetching current school');
            this.adminSchoolSv.fetchSchoolById(this.schoolId).subscribe((school) => {
              this.school = school;
              console.log('Current school is: ' + JSON.stringify(this.school));
            });
          }

          console.log('user school access is: ' + this.user.schoolAccess.length);
          if (this.user.schoolAccess && this.user.schoolAccess.length > 0) {
            console.log('fetching schools the user has access to');
            const allSchoolIds = this.user.schoolAccess.map(a => a.schoolId).join(',');
            const filter = new SchoolFilter();
            filter.schoolIds = allSchoolIds;
            filter.limit = 50;
            filter.includeTeacherSchools = 1;
            this.adminSchoolSv.fetchSchools(filter).subscribe((schools) => {
              console.log('get schools');
              this.teacherTestSchool = schools.find(s => s.isTeacherTestSchool) || null;
            });
          }

        });

      }

    });

  }

  onPageChanged(item: EVOSegmentedControlItem) {

    this.currentItem = item;
    this.router.navigate(['admin', 'schools', this.schoolId, 'users', this.userId, item.key]);

  }

  onSchoolClicked() {

    this.router.navigate(['admin', 'schools', this.schoolId, 'detail', 'teachers']);

  }

  onTeacherTestSchoolClicked() {

    this.router.navigate(['admin', 'schools', this.teacherTestSchool._id, 'detail', 'students']);

  }

}
